import { Link } from "react-router-dom";
import { useLang } from "../contexts/LanguageContext";
import { Anchor, Mail } from "lucide-react";

const COMPANY_EMAIL = "g.nappi@wctrading-italy.com";

export function Footer() {
  const { t } = useLang();

  return (
    <footer
      data-testid="site-footer"
      className="bg-[#1A120B] text-[#F5EFE3] mt-24"
    >
      <div className="px-6 md:px-12 lg:px-20 py-20 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5 space-y-6">
          <div className="flex items-center gap-2">
            <Anchor strokeWidth={1.4} className="h-5 w-5 text-secondary" />
            <span className="font-display text-2xl tracking-tight">
              World Commodity Supply
            </span>
          </div>
          <p className="font-display text-2xl md:text-3xl text-balance leading-tight text-[#F5EFE3]/90">
            {t.footer.tagline}
          </p>
        </div>

        <div className="md:col-span-3 space-y-4">
          <p className="tracking-eyebrow text-xs uppercase text-secondary">
            {t.footer.sections}
          </p>
          <ul className="space-y-3 text-sm text-[#F5EFE3]/80">
            <li>
              <a href="/#products" data-testid="footer-link-products">
                {t.nav.products}
              </a>
            </li>
            <li>
              <a href="/#producers" data-testid="footer-link-producers">
                {t.nav.producers}
              </a>
            </li>
            <li>
              <a href="/#logistics" data-testid="footer-link-logistics">
                {t.nav.logistics}
              </a>
            </li>
            <li>
              <a
                href="/#certifications"
                data-testid="footer-link-certifications"
              >
                {t.nav.certifications}
              </a>
            </li>
            <li>
              <a href="/#contact" data-testid="footer-link-contact">
                {t.nav.contact}
              </a>
            </li>
            <li>
              <Link to="/admin/login" data-testid="footer-link-admin">
                {t.nav.admin}
              </Link>
            </li>
          </ul>
        </div>

        <div className="md:col-span-4 space-y-4">
          <p className="tracking-eyebrow text-xs uppercase text-secondary">
            {t.footer.contact_title}
          </p>
          <div
            data-testid="footer-company"
            className="space-y-1 text-sm text-[#F5EFE3]/90"
          >
            <p className="font-display text-xl text-[#F5EFE3]">
              World Commodity Supply
            </p>
            <p className="text-[#F5EFE3]/70">{t.footer.contact_lead}</p>
          </div>
          <a
            href={`mailto:${COMPANY_EMAIL}`}
            data-testid="footer-email-link"
            className="inline-flex items-center gap-2 text-sm text-[#F5EFE3] border-b border-[#F5EFE3]/30 pb-1 hover:border-secondary hover:text-secondary transition-colors"
          >
            <Mail strokeWidth={1.5} size={14} />
            {COMPANY_EMAIL}
          </a>
          <div className="pt-2 text-[11px] tracking-eyebrow uppercase text-[#F5EFE3]/50 space-y-1">
            <p>{t.footer.privacy} · {t.footer.terms}</p>
          </div>
        </div>
      </div>
      <div className="border-t border-[#F5EFE3]/10 px-6 md:px-12 lg:px-20 py-6 text-xs text-[#F5EFE3]/50 flex flex-col md:flex-row md:justify-between gap-2">
        <span>{t.footer.copyright}</span>
        <span>Sea freight powered by MSC</span>
      </div>
    </footer>
  );
}
